<template>
  <el-dialog
    v-el-drag-dialog
    :visible.sync="innerVisible"
    :title="$t('queryJob.installationInstructions')"
    width="300px"
    :close-on-click-modal="false"
  >
    <el-form label-width="0">
      <el-form-item>
        <el-checkbox v-model="takePhotos">{{ $t('queryJob.whetherTakePhotos') }}</el-checkbox>
      </el-form-item>
      <el-form-item>
        <el-input
          v-model="notes"
          type="textarea"
          :rows="5"
        />
      </el-form-item>
    </el-form>
    <span slot="footer">
      <el-button type="primary" @click="clickHandler">{{ $t('CargoMsg.Cargo_Confirm') }}</el-button>
      <el-button @click="innerVisible=false">{{ $t('Message.Cancel') }}</el-button>
    </span>
  </el-dialog>
</template>

<script>
import { jointBoard } from '@/api/AirExport/airExportLoadingNotes'

export default {
  name: 'LoadingNoteDialog',
  props: {
    visible: { type: Boolean, required: true },
    jobs: { type: Array, required: true }
  },
  data() {
    return {
      innerVisible: this.visible,
      takePhotos: false,
      notes: ''
    }
  },
  watch: {
    visible(newVal) {
      if (newVal) {
        this.takePhotos = false
        this.notes = ''
        for (const item of this.jobs) {
          if (item.airExportLoadingNotes) {
            this.takePhotos = item.airExportLoadingNotes.takePhotos
            this.notes = item.airExportLoadingNotes.notes
            break
          }
        }
      }
      this.innerVisible = newVal
    },
    innerVisible(newVal) {
      this.$emit('update:visible', newVal)
    }
  },
  methods: {
    clickHandler() {
      jointBoard({
        takePhoto: this.takePhotos,
        notes: this.notes,
        jobKeys: Array.from(this.jobs, p => p.uuid)
      }).then(res => {
        for (const item of this.jobs) {
          if (item.airExportLoadingNotes) {
            item.airExportLoadingNotes.takePhotos = this.takePhotos
            item.airExportLoadingNotes.notes = this.notes
            break
          }
        }
        this.innerVisible = false
        this.$emit('callback')
      })
    }
  }
}
</script>
